import { render, staticRenderFns } from "./feedback.panel.vue?vue&type=template&id=44161888"
import script from "./feedback.panel.vue?vue&type=script&lang=js"
export * from "./feedback.panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports